var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgCalendario(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.55 104.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d3dcfb;}.cls-2{fill:#ebf5fc;}.cls-3{fill:#25baab;}.cls-4{fill:#00a1d0;}.cls-5,.cls-6{fill:#0087ae;}.cls-6{isolation:isolate;opacity:0.6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1022",
    "data-name": "Grupo 1022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_329",
    "data-name": "Caminho 329",
    className: "cls-1",
    d: "M59,92.91H8.62a7.33,7.33,0,0,1-7.33-7.32V78.26H57.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_330",
    "data-name": "Caminho 330",
    className: "cls-2",
    d: "M96.55,34.3V85.59H8.62a7.33,7.33,0,0,1-7.33-7.33v-44L52.58,16Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1020",
    "data-name": "Grupo 1020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1018",
    "data-name": "Grupo 1018"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_334",
    "data-name": "Caminho 334",
    className: "cls-3",
    d: "M58.19,49H54.3a1.71,1.71,0,0,1-1.72-1.71h0V43.34a1.72,1.72,0,0,1,1.72-1.72h3.89a1.72,1.72,0,0,1,1.72,1.72h0v3.89A1.72,1.72,0,0,1,58.19,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_340",
    "data-name": "Caminho 340",
    className: "cls-3",
    d: "M59.91,63.61v-5.5a1.83,1.83,0,0,0-1.83-1.83H54.42a1.83,1.83,0,0,0-1.84,1.83h0v3.67a1.83,1.83,0,0,0,1.83,1.83h5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_343",
    "data-name": "Caminho 343",
    className: "cls-3",
    d: "M43.54,78.26H39.65a1.72,1.72,0,0,1-1.72-1.72h0V72.65a1.72,1.72,0,0,1,1.72-1.72h3.89a1.71,1.71,0,0,1,1.71,1.72h0v3.89a1.71,1.71,0,0,1-1.71,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_344",
    "data-name": "Caminho 344",
    className: "cls-3",
    d: "M87.44,41.62H83.65a1.74,1.74,0,0,0-.64.13,1.77,1.77,0,0,1,1.12,1.64v3.79A1.78,1.78,0,0,1,83,48.83a1.73,1.73,0,0,0,.64.12h3.79a1.77,1.77,0,0,0,1.77-1.77h0V43.39A1.77,1.77,0,0,0,87.44,41.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_345",
    "data-name": "Caminho 345",
    className: "cls-3",
    d: "M72.79,41.62H69a1.84,1.84,0,0,0-.65.13,1.76,1.76,0,0,1,1.12,1.64v3.79a1.77,1.77,0,0,1-1.12,1.65A1.82,1.82,0,0,0,69,49h3.79a1.77,1.77,0,0,0,1.77-1.77h0V43.39A1.77,1.77,0,0,0,72.79,41.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_347",
    "data-name": "Caminho 347",
    className: "cls-3",
    d: "M43.49,41.62h-3.8a1.84,1.84,0,0,0-.65.13,1.76,1.76,0,0,1,1.12,1.64v3.79A1.77,1.77,0,0,1,39,48.83a1.82,1.82,0,0,0,.65.12h3.79a1.77,1.77,0,0,0,1.77-1.77V43.39A1.78,1.78,0,0,0,43.49,41.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_348",
    "data-name": "Caminho 348",
    className: "cls-3",
    d: "M28.83,41.62H25a1.84,1.84,0,0,0-.65.13,1.76,1.76,0,0,1,1.12,1.64v3.79a1.77,1.77,0,0,1-1.12,1.65A1.82,1.82,0,0,0,25,49h3.79a1.77,1.77,0,0,0,1.77-1.77V43.39A1.77,1.77,0,0,0,28.83,41.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_349",
    "data-name": "Caminho 349",
    className: "cls-3",
    d: "M14.18,41.62H10.39a1.84,1.84,0,0,0-.65.13,1.76,1.76,0,0,1,1.12,1.64v3.79a1.77,1.77,0,0,1-1.12,1.65,1.82,1.82,0,0,0,.65.12h3.79A1.77,1.77,0,0,0,16,47.18V43.39A1.78,1.78,0,0,0,14.18,41.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_350",
    "data-name": "Caminho 350",
    className: "cls-3",
    d: "M14.18,56.28H10.39a1.82,1.82,0,0,0-.65.12,1.77,1.77,0,0,1,1.12,1.65v3.79a1.76,1.76,0,0,1-1.12,1.64,1.84,1.84,0,0,0,.65.13h3.79A1.77,1.77,0,0,0,16,61.84h0V58.05A1.77,1.77,0,0,0,14.18,56.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_351",
    "data-name": "Caminho 351",
    className: "cls-3",
    d: "M14.18,70.93H10.39a1.64,1.64,0,0,0-.65.13,1.75,1.75,0,0,1,1.12,1.64v3.79a1.77,1.77,0,0,1-1.12,1.65,1.82,1.82,0,0,0,.65.12h3.79A1.77,1.77,0,0,0,16,76.49h0V72.7A1.77,1.77,0,0,0,14.18,70.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_352",
    "data-name": "Caminho 352",
    className: "cls-3",
    d: "M28.83,56.28H25a1.82,1.82,0,0,0-.65.12,1.77,1.77,0,0,1,1.12,1.65v3.79a1.76,1.76,0,0,1-1.12,1.64,1.84,1.84,0,0,0,.65.13h3.79a1.77,1.77,0,0,0,1.77-1.77h0V58.05A1.77,1.77,0,0,0,28.83,56.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_353",
    "data-name": "Caminho 353",
    className: "cls-3",
    d: "M28.83,70.93H25a1.64,1.64,0,0,0-.65.13,1.75,1.75,0,0,1,1.12,1.64v3.79a1.77,1.77,0,0,1-1.12,1.65,1.82,1.82,0,0,0,.65.12h3.79a1.77,1.77,0,0,0,1.77-1.77h0V72.7A1.77,1.77,0,0,0,28.83,70.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_354",
    "data-name": "Caminho 354",
    className: "cls-3",
    d: "M43.49,56.28h-3.8a1.82,1.82,0,0,0-.65.12,1.77,1.77,0,0,1,1.12,1.65v3.79A1.76,1.76,0,0,1,39,63.48a1.84,1.84,0,0,0,.65.13h3.79a1.77,1.77,0,0,0,1.77-1.77h0V58.05A1.76,1.76,0,0,0,43.49,56.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_355",
    "data-name": "Caminho 355",
    className: "cls-3",
    d: "M59.91,63.61V58.05a1.77,1.77,0,0,0-1.77-1.77H54.35a1.82,1.82,0,0,0-.65.12,1.77,1.77,0,0,1,1.12,1.65v3.79a1.76,1.76,0,0,1-1.12,1.64,1.84,1.84,0,0,0,.65.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1019",
    "data-name": "Grupo 1019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_331",
    "data-name": "Caminho 331",
    className: "cls-3",
    d: "M14.23,49H10.34a1.72,1.72,0,0,1-1.72-1.72V43.34a1.71,1.71,0,0,1,1.72-1.71h3.89A1.71,1.71,0,0,1,16,43.34v3.89A1.72,1.72,0,0,1,14.23,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_332",
    "data-name": "Caminho 332",
    className: "cls-3",
    d: "M28.89,49H25a1.72,1.72,0,0,1-1.71-1.72V43.34A1.71,1.71,0,0,1,25,41.63h3.9a1.71,1.71,0,0,1,1.71,1.71v3.89A1.72,1.72,0,0,1,28.89,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_333",
    "data-name": "Caminho 333",
    className: "cls-3",
    d: "M43.54,49H39.65a1.72,1.72,0,0,1-1.72-1.72V43.34a1.71,1.71,0,0,1,1.72-1.71h3.89a1.7,1.7,0,0,1,1.71,1.71v3.89A1.71,1.71,0,0,1,43.54,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_335",
    "data-name": "Caminho 335",
    className: "cls-3",
    d: "M72.84,49H69a1.72,1.72,0,0,1-1.72-1.72h0V43.34A1.71,1.71,0,0,1,69,41.63h3.89a1.71,1.71,0,0,1,1.72,1.71h0v3.89A1.72,1.72,0,0,1,72.84,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_336",
    "data-name": "Caminho 336",
    className: "cls-3",
    d: "M87.49,49H83.6a1.71,1.71,0,0,1-1.71-1.72h0V43.34a1.7,1.7,0,0,1,1.71-1.71h3.89a1.71,1.71,0,0,1,1.72,1.71h0v3.89A1.72,1.72,0,0,1,87.49,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_337",
    "data-name": "Caminho 337",
    className: "cls-3",
    d: "M14.23,63.61H10.34a1.72,1.72,0,0,1-1.72-1.72h0V58a1.72,1.72,0,0,1,1.71-1.72h3.9A1.72,1.72,0,0,1,16,58h0v3.89A1.73,1.73,0,0,1,14.23,63.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_338",
    "data-name": "Caminho 338",
    className: "cls-3",
    d: "M28.89,63.61H25a1.72,1.72,0,0,1-1.71-1.72h0V58A1.71,1.71,0,0,1,25,56.28h3.89A1.72,1.72,0,0,1,30.6,58h0v3.89A1.72,1.72,0,0,1,28.89,63.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_339",
    "data-name": "Caminho 339",
    className: "cls-3",
    d: "M43.54,63.61H39.65a1.72,1.72,0,0,1-1.72-1.72h0V58a1.72,1.72,0,0,1,1.71-1.72h3.9A1.71,1.71,0,0,1,45.25,58h0v3.89A1.72,1.72,0,0,1,43.54,63.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_341",
    "data-name": "Caminho 341",
    className: "cls-3",
    d: "M14.23,78.26H10.34a1.72,1.72,0,0,1-1.72-1.72h0V72.65a1.72,1.72,0,0,1,1.72-1.72h3.89A1.72,1.72,0,0,1,16,72.65h0v3.89A1.72,1.72,0,0,1,14.23,78.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_342",
    "data-name": "Caminho 342",
    className: "cls-3",
    d: "M28.89,78.26H25a1.72,1.72,0,0,1-1.71-1.72h0V72.65A1.72,1.72,0,0,1,25,70.93h3.9a1.72,1.72,0,0,1,1.71,1.72h0v3.89a1.72,1.72,0,0,1-1.71,1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_346",
    "data-name": "Caminho 346",
    className: "cls-3",
    d: "M58.14,41.62H54.35a1.84,1.84,0,0,0-.65.13,1.76,1.76,0,0,1,1.12,1.64v3.79a1.77,1.77,0,0,1-1.12,1.65,1.82,1.82,0,0,0,.65.12h3.79a1.77,1.77,0,0,0,1.77-1.77h0V43.39A1.77,1.77,0,0,0,58.14,41.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_356",
    "data-name": "Caminho 356",
    className: "cls-3",
    d: "M43.48,70.93H39.69a1.64,1.64,0,0,0-.65.13,1.75,1.75,0,0,1,1.12,1.64v3.79A1.77,1.77,0,0,1,39,78.14a1.82,1.82,0,0,0,.65.12h3.79a1.77,1.77,0,0,0,1.77-1.77h0V72.7A1.77,1.77,0,0,0,43.48,70.93Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_357",
    "data-name": "Caminho 357",
    className: "cls-1",
    d: "M91.46,32.18V85.59h5.09V34.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_358",
    "data-name": "Caminho 358",
    className: "cls-4",
    d: "M96.55,34.3V16a7.33,7.33,0,0,0-7.33-7.33H8.62A7.33,7.33,0,0,0,1.29,16h0V34.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1017",
    "data-name": "Grupo 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1013",
    "data-name": "Grupo 1013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_359",
    "data-name": "Caminho 359",
    className: "cls-5",
    d: "M24.38,17.64H19.61a1.66,1.66,0,0,1,0-3.32h4.77a1.66,1.66,0,0,1,0,3.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1014",
    "data-name": "Grupo 1014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_360",
    "data-name": "Caminho 360",
    className: "cls-5",
    d: "M36.09,17.64H31.32a1.66,1.66,0,0,1,0-3.32h4.77a1.66,1.66,0,0,1,0,3.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1015",
    "data-name": "Grupo 1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_361",
    "data-name": "Caminho 361",
    className: "cls-5",
    d: "M66.51,17.64H61.74a1.66,1.66,0,0,1,0-3.32h4.77a1.66,1.66,0,0,1,0,3.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1016",
    "data-name": "Grupo 1016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_362",
    "data-name": "Caminho 362",
    className: "cls-5",
    d: "M78.23,17.64H73.46a1.66,1.66,0,1,1,0-3.32h4.77a1.66,1.66,0,0,1,0,3.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_363",
    "data-name": "Caminho 363",
    className: "cls-2",
    d: "M32.43,15.07a4.58,4.58,0,0,1-9.16,0V5.91a4.58,4.58,0,1,1,9.16,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_364",
    "data-name": "Caminho 364",
    className: "cls-2",
    d: "M74.56,15.07a4.58,4.58,0,0,1-9.16,0V5.91a4.58,4.58,0,1,1,9.16,0v9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_365",
    "data-name": "Caminho 365",
    className: "cls-1",
    d: "M70,1.33a4.52,4.52,0,0,0-2.54.77,4.57,4.57,0,0,1,2,3.81v9.15a4.55,4.55,0,0,1-2,3.81,4.57,4.57,0,0,0,6.35-1.26,4.63,4.63,0,0,0,.77-2.55V5.91A4.58,4.58,0,0,0,70,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_366",
    "data-name": "Caminho 366",
    className: "cls-1",
    d: "M27.85,1.33a4.54,4.54,0,0,0-2.54.77,4.57,4.57,0,0,1,2,3.81v9.15a4.55,4.55,0,0,1-2,3.81,4.57,4.57,0,0,0,7.12-3.81V5.91A4.58,4.58,0,0,0,27.85,1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_367",
    "data-name": "Caminho 367",
    className: "cls-5",
    d: "M89.22,8.65H84.13A7.33,7.33,0,0,1,91.46,16h0V34.3h5.08V16a7.33,7.33,0,0,0-7.32-7.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_368",
    "data-name": "Caminho 368",
    className: "cls-5",
    d: "M1.29,25.31H96.55v3.32H1.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1021",
    "data-name": "Grupo 1021"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_38",
    "data-name": "Elipse 38",
    className: "cls-4",
    cx: 76.45,
    cy: 79.16,
    r: 23.81
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_39",
    "data-name": "Elipse 39",
    className: "cls-2",
    cx: 76.45,
    cy: 79.16,
    r: 17.46
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_369",
    "data-name": "Caminho 369",
    className: "cls-5",
    d: "M76.45,77.43A1.44,1.44,0,0,1,75,76h0V68.05a1.44,1.44,0,0,1,2.88,0V76a1.45,1.45,0,0,1-1.44,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_370",
    "data-name": "Caminho 370",
    className: "cls-5",
    d: "M84.39,80.6H79.62a1.44,1.44,0,0,1,0-2.87h4.77a1.44,1.44,0,1,1,0,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_371",
    "data-name": "Caminho 371",
    className: "cls-6",
    d: "M76.45,55.35c-.74,0-1.48,0-2.2.1a23.81,23.81,0,0,1,0,47.42c.73.07,1.46.1,2.2.1a23.82,23.82,0,0,0,0-47.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_372",
    "data-name": "Caminho 372",
    className: "cls-1",
    d: "M76.45,61.7a17.93,17.93,0,0,0-2.2.14,17.46,17.46,0,0,1,0,34.65,17.46,17.46,0,0,0,4.4-34.65A18.05,18.05,0,0,0,76.45,61.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_40",
    "data-name": "Elipse 40",
    className: "cls-3",
    cx: 76.45,
    cy: 79.16,
    r: 3.17
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCalendario);
export default __webpack_public_path__ + "static/media/img-calendario.7e56fa9b.svg";
export { ForwardRef as ReactComponent };